export default __webpack_public_path__ + "static/media/flag-bangladesh.c7877e3f.svg";